import styled from "styled-components"

import truckDark from "../../images/svg/topYogunluk/truck-dark.svg"
import truckLight from "../../images/svg/topYogunluk/truck-light.svg"

import yukDark from "../../images/svg/topYogunluk/list-dark.svg"
import yukLight from "../../images/svg/topYogunluk/list-light.svg"

import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { showModal } from "../../features/modal/modalSlice"
import { getGarajDetay } from "../../features/admin/adminSlice"
import {BsCalendar2Check} from "react-icons/bs"

const Container = styled.div`
    width: 100%;
    padding: 20px;
    border-radius: 15px;
    background-color: ${({theme}) => theme.secondaryBgColor};
    color: ${({ theme }) => theme.mainTextColor};
    cursor: pointer;

    display: flex;
    justify-content: space-between;
    align-items: center;


    .garaj-name{
      font-size: var(--font-size-md);
      font-weight: var(--font-weight-lg);
      width: 20%;
    }

    .yogunluk-container{
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 60%;

      .yogunluk-item{
        display: flex;
        align-items: center;

        img{
          width: 25px;
          margin-right: 10px;
        }

        .text{
          font-size: var(--font-size-md);
          font-weight: var(--font-weight-lg);
          width: 140px;
        }

        .number{
          font-size: var(--font-size-md);
          font-weight: var(--font-weight-lg);
        }

      }

    }

    .date-container{
      width: 20%;
      display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 10px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);

        .icon-container{
            display: flex;
            justify-content: center;
            align-items: center;

            .icon{
                font-size: 1.2rem;
            }
        }
    }


`

const Line = styled.div`
  width: 250px;
  height: 12px;
  margin-right: 20px;

  .line{
    height: 100%;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    background: ${({type}) => type === "arac" ? "  linear-gradient(to right, green 40%, yellow 75%, red 100%)" : type === "yuk" && "linear-gradient(to right, red 40%, yellow 75%, green 100%)"} ;


    .inner{
      transition: 1s;
      height: 100%;
      width: ${({sizeInner}) => sizeInner};
      background-color: transparent;
    }

    .upper{
      transition: 1s;
      width: ${({sizeUpper}) => sizeUpper};
      background-color: grey;
      background-color:  ${({ theme }) => theme.scrollThumbColor};
      height: 100%;
    }
  }
`

const GarajListItem = ({item}) => {
    
    const {theme} = useSelector(state => state.layout)

    const dispatch = useDispatch()
    const {isUpdatedGarajDetay} = useSelector(state => state.admin)

    const [isOk, setIsOk] = useState(false)
    
    const [yukCounter, setYukCounter] = useState(0)

    const [aracCounter, setAracCounter] = useState(0)

    const yukTimer = 1000 / item.loadDensity
    const aracTimer = 1000 /item.vehicleDensity

    useEffect(() => {
        const timeout = setTimeout(() => {
          setIsOk(true)
        } ,200)
  
        return ()=> {
          clearTimeout(timeout)
        }
      },[])


      useEffect(()=> {
        const interval1 = setInterval(() => {
            if(item.loadDensity > yukCounter){
                setYukCounter((yukCounter) => yukCounter + 1);
            }
          }, yukTimer);
      
          return () => {
            clearInterval(interval1);
          };
      },[yukCounter ])

      useEffect(()=> {
        const interval2 = setInterval(() => {
            if(item.vehicleDensity > aracCounter){
                setAracCounter((aracCounter) => aracCounter + 1);
            }
          }, aracTimer);

          return () => {
            clearInterval(interval2);
          };
      },[aracCounter])


  return (
    <Container onClick={()=> {dispatch(showModal("garajDetay")); dispatch(getGarajDetay(item.branchId))}}>
        <div className="garaj-name">{item.branchName} Kamyon Garajı</div>
        <div className="yogunluk-container">
            <div className="yogunluk-item">
            <img src={theme === "dark" ? yukLight : yukDark} alt={item.garaj+"yuk"} />
            <div className="text">Yük Yoğunluğu</div>
                <div className="line-container">
                    <Line type={"yuk"} sizeInner={isOk ? `${item.loadDensity}%`: 0} sizeUpper={isOk ? `${100 - item.loadDensity}%`: "100%"}>
                        <div className="line">
                            <div className="inner"></div>
                            <div className="upper"></div>
                        </div>
                    </Line>
                </div>
                {
                    !isUpdatedGarajDetay ?
                    <div className="number" style={{color: yukCounter <= 50 ? "#FF0000" : yukCounter <= 75 ? "#EBB00E" :"#0EAC00" }}>%{yukCounter}</div>:
                    <div className="number" style={{color: yukCounter <= 50 ? "#FF0000" : yukCounter <= 75 ? "#EBB00E" :"#0EAC00" }}>%{item.loadDensity}</div>

                }
            </div>
            <div className="yogunluk-item">
            <img src={theme === "dark" ? truckLight : truckDark } alt={item.garaj+"yuk"} />
            <div className="text">Araç Yoğunluğu</div>

            <div className="line-container">
                    <Line type={"arac"} sizeInner={isOk ? `${item.vehicleDensity}%`: 0} sizeUpper={isOk ? `${100 - item.vehicleDensity}%`: "100%"} >
                        <div className="line">
                            <div className="inner"></div>
                            <div className="upper"></div>
                        </div>
                    </Line>
                </div>
        
            {
                !isUpdatedGarajDetay ?
                <div className="number" style={{color: aracCounter <= 50 ? "#0EAC00" : aracCounter <= 75 ? "#EBB00E" :"#FF0000" }}>%{aracCounter}</div>:
                <div className="number" style={{color: aracCounter <= 50 ? "#0EAC00" : aracCounter <= 75 ? "#EBB00E" :"#FF0000" }}>%{item.vehicleDensity}</div>

            }

            </div>
        </div>
        <div className="date-container">
            <div className="icon-container">
                <BsCalendar2Check className="icon"/>
            </div>
            <div className="date">{item.entryTime}</div>
            <div className="time">{item.time}</div>
        </div>
    </Container>
  )
}

export default GarajListItem